import { Box, Flex } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LouiseOffer } from '../../../../../../../types/Quotes';
import InsuranceCompanyLogo from '../../../../../../common/src/components/InsuranceCompanyLogo';
import { getGuaranteeNameForKey } from '../../../../services/productFactoryService';
import { toEuro } from '../../../../utils/stringUtils';

// Comparison
import ComparisonBarClose from './ComparisonBarClose';
import ComparisonBarItemContent from './ComparisonBarItemContent';

interface Props {
  offer: LouiseOffer;
  onRemove: () => void;
}

const ComparisonBarItem: React.FC<React.PropsWithChildren<Props>> = ({
  offer,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <ComparisonBarItemWrapper>
      <ComparisonBarItemContent
        Logo={
          <InsuranceCompanyLogo insuranceCompany={offer.info.company.key} />
        }
        insuranceCompany={offer.info.company?.name || t('Insurer')}
        insurance={getGuaranteeNameForKey(
          offer.info.insurance_name,
          offer.guarantee_content,
        )}
        price={offer.premium ? toEuro(offer.premium.total_premium) : ''}
        options={offer.selected_guarantees}
      />
      <Box pos="absolute" top="0" right="0" transform="translate(50%, -50%)">
        <ComparisonBarClose onRemove={onRemove} />
      </Box>
    </ComparisonBarItemWrapper>
  );
};

const ComparisonBarItemWrapper: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <Flex
      flexDirection="column"
      w="100%"
      h="100%"
      pos="relative"
      alignItems={{ base: 'start', laptopL: 'center' }}
      justifyContent="center"
      p={{
        base: '2',
        laptopL: '4',
      }}
      backgroundImage={`url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='%23DBDDE1FF' stroke-width='2' stroke-dasharray='12%2c12' stroke-dashoffset='12' stroke-linecap='square'/%3e%3c/svg%3e");`}
      borderRadius="md"
    >
      {children}
    </Flex>
  );
};

export default ComparisonBarItem;
